export const TaskSlaLevelColumnId = {
  LEVEL_NAME: 'levelName',
  SLA: 'sla',
  POTENTIAL_ASSIGNEES: 'potentialAssigneesFullNames',
  ASSIGNED_USERS: 'assignedUsersFullNames',
  ASSIGNMENT_TYPE: 'taskAssignmentType',
  START_DATE: 'startDate',
};

export const taskSlaTableWidthMap = {
  [TaskSlaLevelColumnId.LEVEL_NAME]: '15%',
  [TaskSlaLevelColumnId.SLA]: '12%',
  [TaskSlaLevelColumnId.POTENTIAL_ASSIGNEES]: '22%',
  [TaskSlaLevelColumnId.ASSIGNED_USERS]: '22%',
  [TaskSlaLevelColumnId.ASSIGNMENT_TYPE]: '12%',
  [TaskSlaLevelColumnId.START_DATE]: '17%',
};
